import './PaperlessPreferencesAccountGroup.scss';
import React, {Fragment} from 'react';
import DisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import { ReactComponent as QuestionCircle } from 'assets/icons/question-circle.svg';
import {
  AAMBeaconControlGroup,
  AAMBeaconControl
} from "components/shared/Beacon";

const PaperlessPreferencesAccountGroup = ({
  title,
  note,
  isEmailDelivery,
  handleChange,
  serviceTypeId,
  product,
  modalContent,
  disabledRadioGroup = false
}) => {
  return (
    <div className="preferences-account-radio-group">
      <AAMBeaconControlGroup>
        <div slot="label" className="document-name">
          {title}
          <DisclosureModal
            icon={<QuestionCircle slot={'suffix'} />}
            closeOnClickOut
            dataTestId={`${serviceTypeId + '-'}tooltip-button`}>
            <Fragment>
              <div className="b-typography-serif--headline--200">{title}</div>
              <div className="b-typography-sans-serif--body--200 b-font-weight-light">{modalContent}</div>
            </Fragment>
          </DisclosureModal>
        </div>
        <AAMBeaconControl inline>
          <label slot="label" htmlFor={`${product}-${title}-email`}>Email</label>
          <input value="email"
                 type="radio"
                 disabled={disabledRadioGroup}
                 checked={isEmailDelivery}
                 id={`${product}-${title}-email`}
                 name={`${product}-${title}-email`}
                 onChange={(event) => handleChange(event, serviceTypeId, product)} />
        </AAMBeaconControl>
        <AAMBeaconControl inline>
          <label slot="label" htmlFor={`${product}-${title}-usmail`}>U.S. Mail</label>
          <input value="usmail"
                 type="radio"
                 disabled={disabledRadioGroup}
                 checked={!isEmailDelivery}
                 id={`${product}-${title}-usmail`}
                 name={`${product}-${title}-usmail`}
                 onChange={(event) => handleChange(event, serviceTypeId, product)} />
        </AAMBeaconControl>
        <div slot="hint">{note}</div>
      </AAMBeaconControlGroup>
    </div>
  );
};

export default PaperlessPreferencesAccountGroup;
